import { useEffect } from "react";

import { getGlofoxLegacyApiReferenceHref } from "@/lib/portal/glofox-routes";

/** Client redirect for static SPA hosting (S3); server redirects are unavailable. */
export function ApiReferenceRedirect() {
  useEffect(() => {
    window.location.replace(getGlofoxLegacyApiReferenceHref());
  }, []);

  return null;
}
